import React from 'react';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

type IconButtonCustomProps = {
  text: string;
  src: string;
  tooltip?: string;
  onClick?: () => void;
};

const IconButtonCustom: React.FC<IconButtonCustomProps> = (props) => {
  const handleClick = () => {
    props.onClick?.();
  };

  return (
    <IconButton title={props.tooltip} sx={{ p: 0 }} onClick={handleClick}>
      <img
        src={props.src}
        style={{ width: '20px', height: '20px' }}
        alt='icon'
      />
      <Typography
        component='label'
        sx={{
          fontSize: '12px',
          fontWeight: 700,
          lineHeight: '14.4px',
          color: '#23B7E5',
          cursor: 'pointer'
        }}
      >
        {props.text}
      </Typography>
    </IconButton>
  );
}

export default IconButtonCustom;